import { render, staticRenderFns } from "./ChatMessageComposer.vue?vue&type=template&id=1acb9eb2&scoped=true"
import script from "./ChatMessageComposer.vue?vue&type=script&lang=js"
export * from "./ChatMessageComposer.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageComposer.vue?vue&type=style&index=0&id=1acb9eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acb9eb2",
  null
  
)

export default component.exports